import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { BillingAdvisorProPlanUsageObject } from '@/modules/billing/models/BillingAdvisorProPlanUsageObject';
import { StripePaymentMethod } from '@/modules/billing/models/stripe/StripePaymentMethod';
import { StripeBillingPortalSession } from '@/modules/billing/models/stripe/StripeBillingPortalSession';
import { StripeInvoice } from '@/modules/billing/models/stripe/StripeInvoice';
import BillingAdvisorProResource from '@/modules/billing/resources/BillingAdvisorProResource';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { PlatformProduct } from '@/modules/platformproduct/models/PlatformProduct';

export class BillingAdvisorProService extends BaseService {
  /**
   * @var {BillingAdvisorProResource}
   */
  resource;

  constructor() {
    super();

    this.resource = BillingAdvisorProResource;
  }

  async getActivePlan(): Promise<BillingAdvisorProPlanUsageObject> {
    return this.resource.getActivePlan();
  }

  async getNextPlan(): Promise<BillingAdvisorProPlanUsageObject> {
    return this.resource.getNextPlan();
  }

  async getPaymentMethod(): Promise<StripePaymentMethod> {
    return this.resource.getPaymentMethod();
  }

  async createPaymentMethodPortalSession(): Promise<void> {
    const session: StripeBillingPortalSession =
      await this.resource.createPaymentMethodPortalSession(window.location.href);

    DocumentUIService.openUrl(session.url, '_self');
  }

  async setSubscriptionDefaultPaymentMethod(): Promise<void> {
    return this.resource.setSubscriptionDefaultPaymentMethod();
  }

  async getInvoices(params: Params = {}): Promise<StripeInvoice[]> {
    return this.resource.getInvoices(params);
  }

  async unCancelPlan(): Promise<void> {
    return this.resource.unCancelPlan();
  }

  async changePlan(productKey: ProductKey): Promise<PlatformProduct> {
    return this.resource.changePlan(productKey);
  }
}

export default new BillingAdvisorProService();
